import contact from './contact'
import creatorHub from './creatorHub'
import influencers from './influencers'
import keys from './keys'
import magazine from './magazine'
import marketing from './marketing'
import mundoIndie from './mundo-indie'
import newsletterAgency from './newsletter'
import services from './services'
import appThemes from './themes'
import testimonialInitiatives from './testimonialInitiatives'
import testimonialRequests from './testimonialRequests'
import userTestimonials from './userTestimonials'
import showcase from './showcase'
import studioOnboarding from './studioOnboarding'
import phase9 from './phase9'
import podcasts from './podcasts'
import wallOfLegends from './wallOfLegends'
import pressKitsAdmin from './press-kits.admin'
import mediaKitsAdmin from './media-kits.admin'
import pressReleaseAssignments from './pressReleaseAssignments'
import programs from './programs'
import fieldActivations from './fieldActivations'

const agency = [
	...appThemes,
	...services,
	...mundoIndie,
	...contact,
	...magazine,
	...newsletterAgency,
	...keys,
	...influencers,
	...marketing,
	...testimonialInitiatives,
	...testimonialRequests,
	...userTestimonials,
	...showcase,
	...studioOnboarding,
	...phase9,
	...podcasts,
	...wallOfLegends,
	...pressKitsAdmin,
	...mediaKitsAdmin,
	...pressReleaseAssignments,
	...creatorHub,
	...programs,
	...fieldActivations,
	{
		path: '/agency/budget-builder',
		name: 'agency-budget-builder',
		component: () => import('@/views/agency/budget-builder/index.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,influencers',
		},
	},
	{
		path: '/agency/dashboard',
		name: 'agency-dashboard',
		component: () => import('@/views/agency/dashboard/Index.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,press-release',
		},
	},
	{
		path: '/agency/services',
		name: 'agency-services',
		component: () => import('@/views/network/blog/posts/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,services',
		},
	},
	{
		path: '/agency/messages',
		name: 'agency-messages-list',
		component: () => import('@/views/messages/Messages.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,messages',
		},
	},
	{
		path: '/agency/notifications',
		name: 'agency-notifications-list',
		component: () => import('@/views/notifications/Notifications.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,marketing',
		},
	},

	// Video Distribution — reviewing studio-submitted videos before the
	// publishing engine can pick them up. Not under the showcase module: this
	// is a standalone product, open to any studio without event enrollment.
	{
		path: '/agency/video-submissions/list',
		name: 'agency-video-submissions-list',
		component: () => import('@/views/agency/video-submissions/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,marketing',
		},
	},
]

export default agency
